module.exports = __webpack_public_path__ + "static/media/baleine4.6dd88957.jpg";